module.exports = __webpack_public_path__ + "static/Fatima-Sami.c71c733d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Fatima-Sami.jpg
// module id = 914
// module chunks = 146520050992020